import { initApp } from '@js/initApp';
import App from './App.vue';
import { APP_MODE } from '../constants/app';
import router from './router';

const lowercasedParams = new URLSearchParams(window.location.search.toLowerCase());
const autostartCouchmode = lowercasedParams.has('autostartcouchmode');

const fullPageFeatures = {
	sharing:  true,
	timeline: {
		enable:  true,
		minimal: false,
	},
	player: {
		autoplay:           true,
		contentInfoEnabled: true,
		logo:               true,
		pause:              true,
		seek:               true,
		stop:               false,
		time:               true,
	},
	autostartCouchMode: autostartCouchmode,
};

const init = () => {
	const params = new URLSearchParams(window.location.search);
	const mode = APP_MODE.UNMANAGED;
	const event = window.arenaPlayerEmbedConfig?.event ?? null;
	const lineup = window.arenaPlayerEmbedConfig?.lineup ?? null;
	const eventStats = window.arenaPlayerEmbedConfig?.eventStats ?? null;
	const leagueTable = window.arenaPlayerEmbedConfig?.leagueTable ?? null;
	const tagTemplates = window.arenaPlayerEmbedConfig?.tagTemplates ?? null;
	const eventTagId = Number.parseInt(window.arenaPlayerEmbedConfig?.eventTagId);
	const playerType = window.arenaPlayerEmbedConfig?.playerType ?? null;
	const password = params.get('password') ? atob(params.get('password')) : null;

	const data = {
		mode,
		event,
		lineup,
		eventStats,
		leagueTable,
		tagTemplates,
		eventTagId,
		playerType,
		password,
		features: fullPageFeatures,
	};

	return initApp('fullpage', App, router, data);
};

export { init };
